module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h5', [_vm._v("Enter Publisher's Name")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('name')
    },
    attrs: {
      "data-vv-delay": "1000",
      "name": "name",
      "type": "text",
      "placeholder": "Publisher name"
    },
    model: {
      value: (_vm.credentials.name),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "name", $$v)
      },
      expression: "credentials.name"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('name')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--success",
    attrs: {
      "disabled": !_vm.formValid
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus el-icon-left"
  }), _vm._v("\n            Create Publisher\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--danger",
    attrs: {
      "to": "/admin/bidders/"
    }
  }, [_vm._v("Cancel")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Create Publisher For Bidder")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18236ec9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/bidder/Publisher.vue
// module id = 666
// module chunks = 2